<template>
	<div>
		<v-container grid-list-sm fluid class="pa-0">
			<v-form ref="unitary_form">
				<v-layout row wrap>
					<v-flex xs2>
						<div class="ml-2 background--text text--lighten-5 subheading">
							Type *
						</div>
						<v-autocomplete
							solo
							dense
							:rules="[required]"
							name="Package type"
							:menu-props="{contentClass: 'grv-menu'}"
							class="mb-3 grv-input"
							clearable
							:items="package_types"
							v-model="form.parameters.package_type">
						</v-autocomplete>
					</v-flex>
					<v-flex xs6>
						<div class="ml-2 background--text text--lighten-5 subheading">
							Titre *
						</div>
						<v-text-field
							solo
							name="Title"
							clearable
							:rules="[required]"
							class="mb-3 grv-input"
							v-model="form.parameters.title">
						</v-text-field>
					</v-flex>
					<v-flex xs4>
						<div class="ml-2 background--text text--lighten-5 subheading">
							Label *
						</div>
						<v-text-field
							solo
							name="Label"
							clearable
							:rules="[required]"
							class="mb-3 grv-input"
							v-model="form.parameters.label">
						</v-text-field>
					</v-flex>
				</v-layout>

				<v-layout row wrap align-end>
					<span class="background--text text--lighten-5 subheading ml-2">
						Sélection des assets
						<v-chip
							label small outline
							class="my-0"
							color="primary"
							v-if="nbAssets > 0">
							{{ nbAssets }} selectionnés
						</v-chip>
					</span>
					<v-spacer></v-spacer>
					<v-btn
						v-if="nbAssets > 0"
						color="warning"
						small
						ref="removeFiles_btn"
						class="my-0 mx-1 color--text text-none"
						@click="form.parameters.assets.list = []">
						<v-icon class="mr-1">close</v-icon>
						Suppprimer les assets
					</v-btn>
				</v-layout>

				<v-text-field
					style="visibility: hidden; height: 0; padding: 0"
					name="Assets"
					v-model="form.parameters.assets.list"
					:rules="[assetsCheck]">
				</v-text-field>

				<div v-if="nbAssets > 0">
					<div
						class="asset-section elevation-4"
						v-for="(asset, assetIndex) in form.parameters.assets.list"
						:key="asset.filepath">
						<span class="caption d-block">
							<v-btn flat icon @click="removeAsset(assetIndex)" class="ma-0">
								<v-icon>close</v-icon>
							</v-btn>
							{{ asset.filepath }}
						</span>
						<v-layout row wrap>
							<v-flex xs2>
								<div class="ml-2 background--text text--lighten-5">
									Type
								</div>
								<v-autocomplete
									solo
									dense
									:menu-props="{contentClass: 'grv-menu'}"
									:rules="[required]"
									:name="`Asset type #${assetIndex}`"
									class="grv-input-dense grv-input"
									clearable
									@change="onAssetTypeChange(assetIndex)"
									:items="asset_types"
									v-model="asset.asset_type">
								</v-autocomplete>
							</v-flex>
							<v-flex xs2>
								<div
									v-if="showRole(asset.asset_type)"
									class="ml-2 background--text text--lighten-5">
									Rôle
								</div>
								<v-autocomplete
									solo
									dense
									:rules="[]"
									v-if="showRole(asset.asset_type)"
									:name="`Asset role #${assetIndex}`"
									:menu-props="{contentClass: 'grv-menu'}"
									class="grv-input-dense grv-input"
									clearable
									:items="asset_roles"
									v-model="asset.role">
								</v-autocomplete>
							</v-flex>
							<v-flex xs5 v-if="asset.asset_type">
								<div class="ml-2 background--text text--lighten-5">
									Langue
								</div>
								<v-autocomplete
									clearable
									solo
									:rules="[]"
									:menu-props="{contentClass: 'grv-menu'}"
									class="grv-input-dense grv-input input-lg"
									dense
									:name="`Asset language #${assetIndex}`"
									:items="languages"
									item-text="text"
									item-value="code"
									v-model="asset.language">
								</v-autocomplete>
							</v-flex>
							<v-flex xs3>
								<div class="ml-2 background--text text--lighten-5">
									<span v-if="asset.asset_type === 'Audio'">Audio Type</span>
									<span v-if="asset.asset_type === 'Subtitle'">Subtitle Type</span>
								</div>
								<v-autocomplete
									solo
									dense
									clearable
									:rules="[]"
									:menu-props="{contentClass: 'grv-menu'}"
									v-if="asset.asset_type === 'Audio'"
									:name="`Asset audio type #${assetIndex}`"
									class="grv-input-dense grv-input"
									:items="audio_types"
									v-model="asset.audio_type">
								</v-autocomplete>
								<v-autocomplete
									solo
									dense
									clearable
									:rules="[]"
									:menu-props="{contentClass: 'grv-menu'}"
									v-if="asset.asset_type === 'Subtitle'"
									:name="`Asset subtitle type #${assetIndex}`"
									class="grv-input-dense grv-input"
									:items="subtitle_types"
									v-model="asset.subtitle_type">
								</v-autocomplete>
							</v-flex>
						</v-layout>
					</div>
				</div>

				<v-layout class="mt-3 mb-0">
					<v-btn
						color="primary"
						small
						class="mt-0 mx-1 color--text text-none"
						ref="explorer_btn"
						@click="show_explorer = true">
						<v-icon class="mr-1">add</v-icon>
						Fichiers via le filesystem
					</v-btn>
					<v-btn
						color="primary"
						small
						class="mt-0 mx-1 color--text text-none"
						ref="asset_finder_btn"
						@click="show_asset_finder = true">
						<v-icon class="mr-1">add</v-icon>
						Fichiers via asset finder
					</v-btn>
					<SuifaOFDialog
						@suifa-asset-selected="onSuifaAssetSlected($event)">
						<v-icon class="mr-1">download</v-icon>
						Assets fab SUIFA
					</SuifaOFDialog>
				</v-layout>

			</v-form>
		</v-container>

		<v-card class="pa-2 mb-3" v-if="debug">
			<tree-view :data="form" :options="{maxDepth: 3, rootObjectKey: 'Output'}" />
		</v-card>

		<v-card class="pa-2" v-if="debug">
			<tree-view :data="wf_data" :options="{maxDepth: 0, rootObjectKey: 'Job Descriptor'}" />
		</v-card>

		<Explorer
			v-if="show_explorer"
			assetType="file"
			:multiselect="true"
			toolbarTitle="Selectionnez des assets présents sur le filesystem"
			@close="show_explorer = false"
			@selectedAssets="addAssetsFromFinders($event)">
		</Explorer>

		<AssetFinder
			v-if="show_asset_finder"
			:multiselect="true"
			toolbarTitle="Selectionnez des assets via asset finder"
			@close="show_asset_finder = false"
			@selectedAssets="addAssetsFromFinders($event)">
		</AssetFinder>

	</div>
</template>

<script>
import {
	asset_types,
	asset_roles,
	audio_types,
	subtitle_types,
	package_types,
	languages,
	suifa_langue_id_to_xbox_language } from '@/pages/packages/xbox/packager_xbox_enums.js'
import Explorer from '@/components/modal_explorer.vue'
import AssetFinder from '@/components/modal_asset_finder.vue'
import SuifaOFDialog from '@/pages/tools/suifa_of/suifa_of_dialog.vue'

export default {
	props: [ 'wf_data', 'debug', 'form' ],
	components: {
		Explorer,
		AssetFinder,
		SuifaOFDialog
	},
	data () {
		return {
			show_explorer: false,
			show_asset_finder: false,
			selected_assets: [],
			asset_types: asset_types,
			asset_roles: asset_roles,
			audio_types: audio_types,
			subtitle_types: subtitle_types,
			package_types: package_types,
			languages: languages,
			required: v => (v !== '' && v !== null && v !== undefined) || 'Requis'
		}
	},
	computed: {
		nbAssets () {
			try {
				return this.form.parameters.assets.list.length
			} catch (error) {
				return 0
			}
		}
	},
	methods: {
		showRole (asset_type) {
			let needed = [
				'Video',
				'Audio',
				'Subtitle'
			]
			return needed.indexOf(asset_type) !== -1
		},
		onSuifaAssetSlected (assets) {
			for (const asset of assets) {
				let assetType = null
				let role = null
				let language = null
				let audioType = null
				let subtitleType = null
				let typeSup = asset.type_sup.code
				let norme = asset.norme.code
				if (typeSup === 'FHD') {
					if (norme.indexOf('DUB') > -1) {
						assetType = 'Dubcard'
					} else {
						assetType = 'Video'
					}
				}
				if (typeSup === 'FAUDIO') {
					assetType = 'Audio'
				}
				if (typeSup === 'DQ') {
					assetType = 'Subtitle'
				}
				if (norme.indexOf('FA') > -1) {
					role = 'Trailer'
				} else if (norme.indexOf('LM') > -1) {
					role = 'Feature'
				}
				if (asset.audio_language_ids.length) {
					let languageID = asset.audio_language_ids[0]
					if (suifa_langue_id_to_xbox_language.hasOwnProperty(languageID)) {
						language = suifa_langue_id_to_xbox_language[languageID]
					}
				}
				this.form.parameters['assets'].list.push({
					filepath: asset.filepath,
					asset_type: assetType,
					role: role,
					language: language,
					audio_type: audioType,
					subtitle_type: subtitleType
				})
			}
		},
		addAssetsFromFinders (assets) {
			assets.map(asset => {
				let assetIsNew = true
				this.form.parameters['assets'].list.map(selected_asset => {
					if (selected_asset.filepath === asset.path) {
						assetIsNew = false
					}
				})
				if (assetIsNew) {
					this.form.parameters['assets'].list.push({
						filepath: asset.path,
						asset_type: null,
						role: null,
						language: null,
						audio_type: null,
						subtitle_type: null
					})
				}
			})
		},
		removeAsset (assetIndex) {
			this.form.parameters.assets.list.splice(assetIndex, 1)
		},
		onAssetTypeChange (assetIndex) {
			let assetType = this.form.parameters['assets'].list[assetIndex].asset_type
			let assetObj = {}
			if (assetType === 'Video') {
				assetObj = {
					asset_type: this.form.parameters['assets'].list[assetIndex].asset_type,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath,
					role: this.form.parameters['assets'].list[assetIndex].role,
					language: this.form.parameters['assets'].list[assetIndex].language
				}
			} else if (assetType === 'Dubcard') {
				assetObj = {
					asset_type: this.form.parameters['assets'].list[assetIndex].asset_type,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath,
					language: this.form.parameters['assets'].list[assetIndex].language
				}
			} else if (assetType === 'Audio') {
				assetObj = {
					asset_type: this.form.parameters['assets'].list[assetIndex].asset_type,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath,
					role: this.form.parameters['assets'].list[assetIndex].role,
					language: this.form.parameters['assets'].list[assetIndex].language,
					audio_type: this.form.parameters['assets'].list[assetIndex].audio_type
				}
			} else if (assetType === 'Subtitle') {
				assetObj = {
					asset_type: this.form.parameters['assets'].list[assetIndex].asset_type,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath,
					role: this.form.parameters['assets'].list[assetIndex].role,
					language: this.form.parameters['assets'].list[assetIndex].language,
					subtitle_type: this.form.parameters['assets'].list[assetIndex].subtitle_type
				}
			} else {
				assetObj = {
					asset_type: this.form.parameters['assets'].list[assetIndex].asset_type,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath
				}
			}
			this.$set(this.form.parameters.assets.list, assetIndex, assetObj)
		},
		assetsCheck () {
			let assets = this.$commons.deepGet(this.form, 'parameters.assets.list', [])
			if (assets.length === 0) return 'Assets requis'
			return true
		},
		validate () {
			let isValid = this.$refs.unitary_form.validate()
			this.form.isValid = isValid
			return isValid
		},
		resetValidation () {
			return this.$refs.unitary_form.resetValidation()
		}
	},
	mounted () {
		this.$emit('modal-width', '1200px')
	},
	destroyed () {
		this.$emit('modal-width', null)
	}
}
</script>

<style scoped lang="stylus">
.dense_input
	margin-top: 0
	>>>.v-input__slot
		margin-top: 0

>>>.v-input
	margin: 0 .2em
	.v-messages
		min-height: inherit

.asset-section
	border: thin solid var(--v-background-lighten2)
	margin: 10px 0 10px 0
	padding: 0 5px 5px 5px
</style>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/forms/launcher_form_xbox_package.vue